<template>
  <div
    class="ioc-alarm__list flex-valign"
    v-loading="dataLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    :class="{ closeList: isShowList }"
  >
    <div class="blur-bg fire-blur-panel"></div>
    <control-left
      ref="left"
      @handleChangeTime="handleChangeTime"
      @handleRestBtn="handleRestBtn"
      @handleChangeDeviceName="handleChangeDeviceName"
      @handleSearchBtn2="handleSearchBtn2"
    ></control-left>
    <div v-if="isShowSearch" class="ioc-alarm__list__select clearfix"></div>
    <div class="typeF">
      <div class="item" @click="typeClick('')">
        <span>
          <i class="iconfont-lunan icon-lunan-a-zu6059 numIcon"> </i>
          全部
        </span>
        <span class="num">
          {{
            listType.reduce((pre, item) => {
              if (item.num) {
                return pre + item.num;
              } else {
                return pre;
              }
            }, 0)
          }}
          <span style="color: #fff"> 条 </span>
        </span>
      </div>
      <div
        v-for="item in listType"
        :class="
          item.label == '火警'
            ? 'item bordeColorRed'
            : item.label == '故障'
            ? 'item bordeColorYellow'
            : 'item'
        "
        @click="typeClick(item)"
        :key="item.name"
      >
        <span>
          <i :class="showIcon(item.value)" class="iconfont-lunan numIcon"></i>
          {{ item.label }}
        </span>
        <span
          :class="
            item.label == '火警'
              ? 'num colorRed'
              : item.label == '故障'
              ? 'num colorYellow'
              : 'num'
          "
        >
          {{ item.num || 0 }}
          <span style="color: #fff"> 条 </span>
        </span>
      </div>
      <div
        v-if="systemAttrs.deviceName !== '' && systemAttrs.deviceName !== '电气火灾'"
        style="
          width: 100%;
          display: flex;
          margin-top: 5px;
          height: 25px;
          justify-content: center;
        "
      >
        <el-button
          size="small"
          type="primary"
          plain
          @click="restDevice(systemAttrs)"
          icon="iconfont-lunan icon-lunan-xinghao"
          style="padding: 5px 8px; width: 90%"
        >
          信传复位
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="showOperationData"
          icon="iconfont-lunan icon-lunan-shuju"
          style="padding: 5px 8px; width: 90%"
        >
          运行数据
        </el-button>
      </div>
    </div>
    <el-scrollbar
      ref="alarmList"
      class="ioc-alarm__scrollbar"
      style="padding-bottom: 10px; margin: 230px 0 0"
    >
      <div class="noData" v-if="data.length === 0 && !isShowList">
        <div class="text-center" style="margin-bottom: 10px">
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        {{ $t("realTimeAlarm.title.noData") }}
      </div>

      <ul class="ioc-alarm__list__item">
        <li
          class="map-blur-panel__list-item"
          style="height: 100%"
          v-for="(item, index) in data"
          :key="index"
          @contextmenu.prevent="
            (e) => {
              rightClick(item, e);
            }
          "
          :class="[
            alarmColor(item.alarmLevel),
            clickId == item.alarmId ? 'checkItem' : '',
          ]"
          @click.stop="itemClick(item)"
        >
          <div
            v-if="visibleRightId == item.alarmId"
            class="rightTip"
            :style="{
              left: tipLeft + 'px',
              top: tipTop + 'px',
            }"
          >
            <el-button
              @click.stop="alarmMerge(item)"
              style="border-bottom: 1px solid rgb(218, 220, 224)"
              :title="item.alarmMergeFlag == 1 ? '取消合并' : '告警合并'"
              size="mini"
              >{{ item.alarmMergeFlag == 1 ? "取消合并" : "告警合并" }}</el-button
            >
            <el-button @click.stop="alarmControl(item)" title="告警抑制" size="mini"
              >告警抑制</el-button
            >
            <span title="关闭" class="closeTitle" @click="visibleRightId = ''">
              <i class="el-icon-circle-close"></i>
            </span>
          </div>
          <span class="alarm_level">{{ item.alarmLevel | dic("SENU017") }}</span>
          <div class="alarm_name" :title="item.alarmName">
            {{ item.alarmName }}
          </div>
          <span class="alarm_state"> {{ queryHandleStatus(item.alarmState) }}</span>
          <div class="alarm_area">
            主机名称：{{ item.subDeviceMark ? item.parentDeviceName : item.deviceName }}
          </div>
          <div class="alarm_area">
            厂商：{{ item.subDeviceMark ? item.parentFactoryName : item.factoryName }}
          </div>
          <!-- <div class="alarm_time">{{ item.alarmTime | moment }}</div> -->
          <div class="alarm_time" v-if="alarmMergeFlag == 0">
            日期：{{ item.alarmTime | moment }}
          </div>
          <!-- 合并弹窗 -->
          <div class="alarm_time" v-else>
            <div
              @click.stop="getLeftlistD(item)"
              style="
                display: flex;
                height: 10px;
                line-height: 10px;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="font-size: 12px; color: #fff">合并详情</div>
              <el-button
                type="text"
                style="margin-right: 25px; font-size: 16px; margin-top: 7px"
                :class="[
                  'iconfont-lunan icon-lunan-xiaosanjiaodown',
                  item.isExpand ? 'icon-transform' : '',
                ]"
              >
              </el-button>
            </div>
            <el-collapse-transition>
              <div class="list-detail" v-if="item.isExpand">
                <div class="listTitle">
                  <span>总条数:{{ lefTdata.length }}</span>
                  <el-button
                    size="mini"
                    v-if="item.subSystem != 13"
                    @click.stop="restDevice(item, 2)"
                    type="primary"
                    >信传复位</el-button
                  >
                  <el-button size="mini" @click.stop="dealTask(item)" type="primary"
                    >已下发处理</el-button
                  >
                  <el-button
                    size="mini"
                    :disabled="!lefTdata.length"
                    @click.stop="dealError(item)"
                    type="primary"
                    >误报处理</el-button
                  >
                </div>
                <el-scrollbar
                  :style="{
                    height:
                      lefTdata.length * 35 + 6 > autoHeight
                        ? autoHeight + 'px'
                        : lefTdata.length * 35 + 6 + 'px',
                  }"
                  style="padding: 5px 0"
                >
                  <ul class="listUl">
                    <li
                      v-for="(it, id) in lefTdata"
                      :key="id"
                      class="listLi"
                      @click.stop="itemClick(it)"
                    >
                      <span class="listLi_time">
                        <i class="el-icon-time"></i>
                        {{ it.alarmTime | moment }}</span
                      >
                      <span class="listLi_level alarm_level">{{
                        it.alarmLevel | dic("SENU017")
                      }}</span>
                    </li>
                  </ul>
                </el-scrollbar>
                <div class="listbt">
                  <el-button
                    size="mini"
                    :disabled="
                      lefTdata.length * 40 < autoHeight || autoHeight == 500
                        ? true
                        : false
                    "
                    @click.stop="checkMore"
                    type="primary"
                    >查看更多</el-button
                  >
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </li>
      </ul>
    </el-scrollbar>
  </div>
</template>
<script>
import controlLeft from "./control-left";
import { Dic } from "$utils";
import { api } from "../api";
export default {
  components: {
    controlLeft,
  },
  filters: {
    alarmName(alarmType, item) {
      const value = Dic.findByValue("SENU004009", alarmType);
      return item.deviceName ? value + "_" + item.deviceName : value;
    },
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    listType: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      alarmMergeFlag: "",
      tipLeft: "",
      tipTop: "",
      autoHeight: 110,
      dataLoading: false,
      isShowTypeCard: false,
      isShowSearch: true,
      isShowList: false,
      alarmList: "",
      boxScrollContainer: "",
      scrollView: "",
      subSystem: "",
      eventType: "",
      alarmTypes: [],
      visibleRightId: "",
      rightClickList: [],
      systemAttrs: {
        alarmTime: "",
        deviceName: "",
        alarmStartTime: "",
        alarmEndTime: "",
        isIndeterminate: false,
        checkAll: false,
        checkedSubSystem: [],
        subSystems: Dic.find("SENU004"),
        thirdAlarmDevId: "",
      },
      lefTdata: [],
      deviceId: "",
      clickId: "",
    };
  },
  created() {
    sessionStorage.removeItem("rightClickListFire");
  },
  mounted() {
    this.scrollbar();
  },

  methods: {
    queryHandleStatus(value) {
      return Dic.findByValue("SENU068", Number(value));
    },
    showIcon(val) {
      if (val == "4001") {
        return "icon-lunan-huojing colorRed";
      } else if (val == "4002") {
        return "icon-lunan-guzhang colorYellow";
      } else if (val == "4003") {
        return "icon-lunan-pingbi";
      } else if (val == "4004") {
        return "icon-lunan-jianguan1";
      } else if (val == "4005") {
        return "icon-lunan-fankui2";
      } else if (val == "4006") {
        return "icon-lunan-yanshi";
      } else if (val == "4007") {
        return "icon-lunan-a-lujing4893";
      } else if (val == "4008") {
        return "icon-lunan-dongzuo";
      } else if (val == "4009") {
        return "icon-lunan-dianqihuozai1";
      } else if (val == "40099") {
        return "icon-lunan-1";
      }
    },
    showOperationData() {
      this.$emit("showOperationData2", this.deviceId);
    },

    dealTask(item, type) {
      if (!type) {
        this.$confirm("此操作将对此告警标识为【已下发处理】, 是否确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.dataLoading = true;
            let param = {
              alarmEndTime: this.$parent.queryParams.alarmEndTime,
              alarmLevel: item.alarmLevel,
              alarmMergeCode: item.alarmMergeCode,
              alarmName: item.name,
              alarmStartTime: this.$parent.queryParams.alarmStartTime,
              alarmState: type ? "9" : "4",
              alarmTypeList: this.$parent.queryParams.alarmTypeList,
              subSystemList: this.$parent.queryParams.subSystemList,
            };
            this.$fetch(api.controlRecord.batchUpdateMergeAlarm, param).then((res) => {
              this.dataLoading = false;
              if (res.success) {
                this.$parent.getFireAlarmList(
                  this.$parent.page,
                  this.$parent.queryParams
                );
              } else {
                this.$message.error(res.msgContent);
              }
            });
          })
          .catch(() => {
            //
          });
      } else {
        this.dataLoading = true;
        let param = {
          alarmEndTime: this.$parent.queryParams.alarmEndTime,
          alarmLevel: item.alarmLevel,
          alarmMergeCode: item.alarmMergeCode,
          alarmName: item.name,
          alarmStartTime: this.$parent.queryParams.alarmStartTime,
          alarmState: type ? "9" : "4",
          alarmTypeList: this.$parent.queryParams.alarmTypeList,
          subSystemList: this.$parent.queryParams.subSystemList,
        };
        this.$fetch(api.controlRecord.batchUpdateMergeAlarm, param).then((res) => {
          this.dataLoading = false;
          if (res.success) {
            this.$parent.getFireAlarmList(this.$parent.page, this.$parent.queryParams);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      }
    },
    restDevice(item, type) {
      // this.$confirm('此操作将对主机【' + item.deviceName + '】进行复位, 是否继续?', '提示', {
      this.$confirm(
        type
          ? "此操作将对此告警标识为【主机复位清理(平台)】, 是否确认?"
          : "此操作将对主机【" + item.deviceName + "】进行复位, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (type) {
            this.dealTask(item, "2");
            return;
          }
          this.$emit("restDevice");
        })
        .catch(() => {
          //
        });
    },
    typeClick(val) {
      this.$emit("typeChange", val ? val.value : "");
    },
    checkMore() {
      if (this.autoHeight > 469) {
        this.autoHeight = 500;
      } else {
        if (this.lefTdata.length * 40 > this.autoHeight) {
          this.autoHeight += 60;
        }
      }
    },
    dealError(val) {
      let params = {
        alarmMergeFlag: val.alarmMergeFlag,
        alarmMergeCode: val.alarmMergeCode,
      };
      this.$emit("resetError", params);
    },
    getLeftlistD(val) {
      let isexpand = val.isExpand;
      this.visibleRightId = "";
      this.lefTdata = [];
      this.data.forEach((el) => {
        el.isExpand = false;
      });
      val.isExpand = !isexpand;
      this.autoHeight = 110;
      if (isexpand) {
        return;
      }
      this.dataLoading = true;
      let params = {
        pageNum: 1,
        pageSize: 100000,
        alarmLevel: this.$parent.queryParams.alarmLevel,
        alarmTypeList: this.$parent.queryParams.alarmTypeList,
        alarmMergeCode: val.alarmMergeCode,
        subSystemList: this.$parent.queryParams.subSystemList,
        alarmName: this.$parent.queryParams.deviceName,
        alarmStartTime: this.$parent.queryParams.alarmStartTime,
        alarmEndTime: this.$parent.queryParams.alarmEndTime,
      };
      this.$fetch(api.alarm.queryAlarmMergeAlarmList, params).then((res) => {
        this.dataLoading = false;
        if (res.success) {
          if (!res.returnObj || !res.returnObj.list) {
            this.$message("暂无合并信息");
            return;
          }
          this.lefTdata = res.returnObj.list || [];
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    isRightShowList(val) {
      let showList = JSON.parse(sessionStorage.getItem("rightClickListFire"));
      if (!showList || !showList.length) {
        return false;
      }
      let isTrue = showList.some((el) => {
        return el == val;
      });
      return isTrue;
    },
    alarmControl(val) {
      this.$emit("handleAlarmControl", val);
    },
    // 告警合并
    alarmMerge(val) {
      let url = "";
      let params = {
        fieldName: "fireAlarmMergeFlag", //实时告警为alarmMergeFlag，消防告警为fireAlarmMergeFlag
      };
      if (val.alarmMergeFlag == 0) {
        // 合并
        url = api.controlRecord.addAlarmFunctionConfig;
        params.fieldValue = "1";
      } else {
        url = api.controlRecord.deleteAlarmFunctionConfig;
      }
      this.autoHeight = 110;
      this.visibleRightId = "";
      this.$fetch(url, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msgContent);
          this.$emit("rightClick");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    rightClick(val, e) {
      this.tipLeft = e.pageX > 300 ? 200 : e.offsetX;
      this.tipTop = e.offsetY + 15;
      this.visibleRightId = val.alarmId;
      val.isExpand = false;
    },
    currentAlarmName(item) {
      if (item) {
        if (item.subSystem === "10") {
          this.$t("realTimeAlarm.title.patrol") + item.deviceName;
        } else {
          return (
            "[" +
            item.subSystemLabel +
            "]" +
            item.alarmTypeLabel +
            (item.deviceName ? "_" + item.deviceName : "")
          );
        }
      } else {
        return "告警详情";
      }
    },

    alarmColor(level) {
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    itemClick(item) {
      this.visibleRightId = "";
      this.clickId = item.alarmId;
      this.$emit("clickAlarm", item);
    },
    scrollbar() {
      this.alarmList = this.$refs.alarmList;
      this.boxScrollContainer = this.alarmList.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");

      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.dataLoading &&
          this.data.length % 30 === 0 &&
          this.data.length !== 0
        ) {
          this.$emit("nextPage");
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    handleChangeDeviceName(val) {
      this.$emit("searchDeviceName", val);
    },
    handTypeLever(val, type) {
      // this.$emit("searchBtnTypeLever", val, type);
      this.$emit("searchBtnTypeLever", val);
    },
    handleRestBtn() {
      // this.systemAttrs.deviceName = "";
      this.systemAttrs.checkedSubSystem = [];
      this.systemAttrs.alarmTime = "";
      console.log(this.systemAttrs);
      this.$emit("restBtn");
    },
    handleSearchBtn2(val) {
      this.systemAttrs.alarmName = val.alarmName;
      val.deviceName
        ? val.deviceName != "全部"
          ? ((this.systemAttrs.deviceName = val.deviceName),
            (this.deviceId = val.deviceId))
          : ((this.systemAttrs.deviceName = ""), (this.deviceId = ""))
        : "";
      this.systemAttrs.thirdAlarmDevId = val.thirdAlarmDevId;
      console.log(this.systemAttrs.deviceName);
      this.handleSearchBtn(val);
    },
    handleSearchBtn(val) {
      this.$emit("searchBtn", val);
    },
    handleChangeTime(val) {
      this.$emit("searchAlarmTime", val);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.typeF {
  width: 100%;
  margin-top: 50px;
  overflow: auto;
  position: absolute;
  // height: 403px;
  display: flex;
  // justify-content: center;
  height: 180px;
  padding: 5px 5px;
  display: flex;
  flex-wrap: wrap;
  @include set_theme_color(background-color, left-menu-bg-color);
  .numIcon {
    margin-right: 3px;
    font-size: 14px;
    @include set_theme_color(color, main-theme-color);
  }
  @keyframes typeKey {
    from {
      // background-color: red;
      opacity: 0.2;
    }
    to {
      opacity: 1;
      // background-color: yellow;
    }
  }
  .item {
    @include set_theme_color(border-color, active-border-color);
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    width: 160px;
    height: 25px;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    margin: 0 5px;
    border-radius: 10px;
    padding: 0 8px;
    &:hover {
      // opacity: 0.8;
      animation: typeKey 1s;
      @include set_theme_color(background-color, main-theme-color);
      .num,
      .numIcon {
        color: #fff !important;
      }
    }
  }
  .num {
    @include set_theme_color(color, main-theme-color);
  }
  .bordeColorRed {
    border-color: red !important;
    &:hover {
      background: red !important;
      .colorRed {
        color: #fff !important;
      }
    }
  }
  .bordeColorYellow {
    border-color: rgb(255, 191, 1) !important;
    &:hover {
      background: rgb(255, 191, 1) !important;
      .colorYellow {
        color: #fff !important;
      }
    }
  }
  .colorRed {
    color: red;
  }
  .colorYellow {
    color: rgb(255, 191, 1);
  }
}
.ioc-alarm__list__item li {
  height: 100%;
}
.ioc-alarm__list {
  height: calc(100% - 20px) !important;
}
.icon-transform {
  transform: rotate(180deg);
}
.list-detail {
  // position: absolute;
  // height: 200px;
  width: 100%;
  // left: 0;
  font-size: 14px;
  @include set_theme_color(background-color, page-bg-color);
  padding: 10px 4px;
  z-index: 2;
  .listTitle {
    height: 24px;
    line-height: 24px;
    margin: px 0;
    display: flex;
    margin-bottom: 10px;
    flex-direction: row;
    justify-content: space-between;
    color: #fff;
    button {
      padding: 7px 5px;
    }
  }
  .listUl {
    // height: 120px;
    // overflow: hidden;
    .listLi {
      position: relative;
      width: 100%;
      padding: 0px;
      margin-bottom: 0px;
      height: 28px;
      line-height: 28px;
      margin: 5px 0;
      color: #fff !important;
      // @include set_theme_color(background-color, dialog-content-bg-color);
      &:hover {
        @include set_theme_color(background-color, main-theme-color);
      }
      .listLi_time {
        font-size: 12px;
        height: 20px;
      }
      .listLi_level {
        width: 50px;
        height: 24px;
        padding-top: 0px;
        text-align: center;
        border-radius: 4px;
        position: absolute;
        margin: 2px 0;
        // right: 27px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .listbt {
    text-align: center;
    margin-top: 5px;
  }
}
.checkItem {
  // @include set_theme_color(background-color, main-theme-color);
  // opacity: 0.8;
  // background-image: linear-gradient(to right, red, yellow);
  .alarm_name {
    color: #fff !important;
  }
}
.rightTip {
  border: 1px solid rgb(218, 220, 224);
  position: absolute;
  top: 33px;
  // height: 55%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  padding: 6px 3px;
  text-align: center;
  border-radius: 4px;
  color: #fff !important;
  background-color: #407aee;
  // @include set_theme_color(background-color, left-menu-bg-color);
  button {
    flex: 1;
    width: 100%;
    border: none;
    // @include set_theme_color(background-color, left-menu-bg-color);
    margin-left: 0;
    color: #070e1d !important;
    &:hover {
      opacity: 0.8;
      background: rgb(200, 200, 201);
      // @include set_theme_color(background-color, transfer-content-color);
      // font-size: 13px;
    }
  }
  .closeTitle {
    color: red;
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
.ioc-alarm__list__title {
  background-color: rgba(0, 0, 0, 0.5);
}
.noData {
  text-align: center;
  height: 80px;
}
</style>
